import { z } from "zod/v4";
import { createEndpointBase } from "./core";
import { GlobalSettingSchemas } from "../ea.schema";
import { GlobalSettingsAutoScreenshotsCleanupSchema } from "../ea.schema";

const base = "settings";
const internal = createEndpointBase(base, "internal");
const screenshotCleanup = createEndpointBase(base, "internal", "screenshotsAutoCleanup");
const global = createEndpointBase(base, "global");

export const settingsEndpoints = {
  settingsInternalGet: internal({
    method: "GET",
    path: "",
    request: z.any(),
    response: z.any(),
    description: "Retrieves internal settings.",
  }),
  settingsInternalPublic: internal({
    method: "GET",
    path: "public",
    request: z.any(),
    response: z.any(),
    description: "Retrieves public internal settings.",
  }),

  settingsInternalScreenshotGet: screenshotCleanup({
    method: "GET",
    path: "",
    request: z.any(),
    response: GlobalSettingsAutoScreenshotsCleanupSchema,
    description: "Retrieves automatic screenshot cleanup settings.",
  }),
  settingsInternalScreenshotSet: screenshotCleanup({
    method: "POST",
    path: "",
    request: GlobalSettingsAutoScreenshotsCleanupSchema,
    response: z.any(),
    description: "Sets automatic screenshot cleanup settings.",
  }),
  settingsInternalScreenshotStats: screenshotCleanup({
    method: "GET",
    path: "stats",
    request: z.any(),
    response: z.any(),
    description: "Retrieves automatic screenshot cleanup statistics.",
  }),

  settingsGlobalGet: global({
    method: "GET",
    path: "",
    request: z.any(),
    response: z.array(GlobalSettingSchemas["general"]),
    description: "Retrieves all global settings.",
  }),
  settingsGlobalUpdate: global({
    method: "PATCH",
    path: "",
    request: GlobalSettingSchemas["update"],
    response: z.any(),
    description: "Updates global settings, optionally handling file uploads for certificates.",
  }),
} as const;
